import ThemeStore from './ThemeStore'

const initializeTheme = () => new ThemeStore()

export type { default as ThemeStore } from './ThemeStore'
export default initializeTheme
